import React from 'react';
import {
	OverlayModalComponentProps,
	OverlayModalProps,
} from '@sharefiledev/sharefile-appshell';
import antdTheme from 'antd/es/theme';
import { DocGenExtensionSlots } from '../../constants';
import { CoreExtensionSlotParams } from '../../types';
import { t } from '../../utils';
import { CreateDocumentTemplateModalBody } from './CreateDocumentTemplateModalBody';

export type CreateDocumentTemplateExtensionModalProps = CoreExtensionSlotParams<{
	cancelInteraction: OverlayModalComponentProps<
		typeof DocGenExtensionSlots.CREATE_DOCUMENT_TEMPLATE_MODAL
	>['cancelInteraction'];
}>;

export const CreateDocumentTemplateExtensionModal = ({
	app,
	cancelInteraction,
}: CreateDocumentTemplateExtensionModalProps) => {
	return <CreateDocumentTemplateModalBody app={app} onClose={cancelInteraction} />;
};

export const getCreateDocumentTemplateModalProps = (
	overrideOverlayModalProps?: OverlayModalProps
) => {
	const { getDesignToken } = antdTheme;
	const token = getDesignToken();
	const overlayModalProps = {
		title: t('createDocumentTemplateModal.title'),
		okButtonProps: { style: { display: 'none' } },
		centered: true,
		width: 680,
		style: {
			marginTop: token.marginMD,
			marginBottom: token.marginLG,
		},
		...overrideOverlayModalProps,
	};

	return overlayModalProps;
};
